﻿function submitForm(event) {
    event.preventDefault();
    $(event.target).parents('form').submit();
}

export function setupVanReviewManufacturers() {
    $(document).on('change', 'form[data-manufacturer-dropdown] select', submitForm);
}